import { render } from "./MakeSalePage.vue?vue&type=template&id=667946a6"
import script from "./MakeSalePage.vue?vue&type=script&lang=js"
export * from "./MakeSalePage.vue?vue&type=script&lang=js"

import "./MakeSalePage.vue?vue&type=style&index=0&id=667946a6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__